(function () {
	'use strict';

	angular.module('mx.SolutionBuilderAgent').service('mx.SolutionBuilderAgent.ConditionsBuilder.Helper', ConditionsBuilderHelper);
	ConditionsBuilderHelper.$inject = ['mx.SolutionBuilderAgent.SchemaService.Enums', 'mx.SolutionBuilderAgent.ConditionsBuilder.Enums'];

	function ConditionsBuilderHelper(SchemaServiceEnums, ConditionsBuilderEnums) {
		var ConditionTypes = ConditionsBuilderEnums.ConditionTypes;
		var DataTypes = SchemaServiceEnums.DataTypes;
		var RelationCardinality = SchemaServiceEnums.RelationCardinality;

		this.definePropertiesForEnums = definePropertiesForEnums;
		this.getConditionTypeByDataType = getConditionTypeByDataType;
		this.getConditionTypeByRelation = getConditionTypeByRelation;

		function definePropertiesForEnums(fieldName, obj) {
			var value = 0;
			var enumeration = obj._builderConfig[fieldName + 's'].enumeration;

			Object.defineProperty(obj, fieldName + 's', {
				writable: false,
				enumerable: false,
				value: enumeration,
			});

			Object.defineProperty(obj, fieldName, {
				enumerable: true,
				get: function () {
					return value;
				},
				set: function (newValue) {
					if (value !== newValue) {
						value = newValue;
						obj.updateOutput();
					}
				},
			});

			Object.defineProperty(obj, fieldName + 'Value', {
				enumerable: false,
				get: function () {
					return obj[fieldName + 's'][obj[fieldName]].value;
				},
				set: function (fieldNewValue) {
					var selected;
					if (
						!this[fieldName + 's'].some(function (item) {
							if (item.value === fieldNewValue) {
								selected = item;
								return true;
							}
						})
					) {
						this[fieldName] = 0;
					} else {
						this[fieldName] = this[fieldName + 's'].indexOf(selected);
					}
					this.updateOutput();
				},
			});

			Object.defineProperty(obj, fieldName + 'Title', {
				enumerable: false,
				get: function () {
					return obj[fieldName + 's'][obj[fieldName]].title;
				},
			});
		}

		function getConditionTypeByDataType(dataType) {
			switch (dataType) {
				case DataTypes.BoolType:
					return ConditionTypes.Boolean;
				case DataTypes.DateType:
					return ConditionTypes.Date;
				case DataTypes.ExpressionGuidType:
					return ConditionTypes.Expression;
				case DataTypes.IntType:
				case DataTypes.LongType:
				case DataTypes.FloatType:
					return ConditionTypes.Number;
				default:
					return ConditionTypes.String;
			}
		}

		function getConditionTypeByRelation(relationType) {
			switch (relationType) {
				case RelationCardinality.OneZeroToOne:
				case RelationCardinality.OneToOne:
				case RelationCardinality.ManyToOne:
				case RelationCardinality.OneToOneZero:
				case RelationCardinality.ManyToZeroOne:
					return ConditionTypes.ObjectReference;
				default:
					return ConditionTypes.ObjectReferences;
			}
		}
	}
})();
